<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-8 col-p h5"><i class="fa fa-globe"></i>Vendor Form</div>
                <div class="col-md-6 col-4 top-corner-items col-p">
                    <!-- <button class="btn btn-primary btn-sm"><i class="fa fa-plus"></i> Add New Vendor</button> -->
                </div>
            </div>
            <!--end header-->

<!--             
            <div class="row row-replace">
                <section class="col-md-12">
                   <div class="row">
                      <div class="col-md-3 mb7">
                         <label>Select Traval Type</label>
                         <select class="form-control">
                            <option>Type</option>
                            <option>Car</option>
                            <option>Hotal</option>
                            <option>Car with Hotal</option>
                         </select>
                      </div>
                      <div class="col-md-3 mb7">
                         <label>Intra City</label>
                         <select class="form-control">
                            <option>Local</option>
                            <option>Outstation</option>
                         </select>
                      </div>
                      <div class="col-md-3 mb7">
                         <label>From</label>
                         <input type="date" class="form-control">
                      </div>
                      <div class="col-md-3 mb7">
                         <label>To</label>
                         <input type="date" class="form-control">
                      </div>
                   </div>
                   <div class="row">
                      <div class="col-md-12 mb7 text-center">
                         <button class="btn btn-sm btn-success ">Search</button> &nbsp;&nbsp;
                         <button type="button" class="btn btn-sm btn-danger ">Reset</button>
                      </div>
                   </div>
                </section>
             </div> -->



             <fieldset class="mb-3">
                <legend class="cus-legend">Contract Details</legend>
            <div class="row">
                <div class="col-md-4">
                   <div class="form-group">
                      <label>Contract Type<span class="text-danger">*</span></label>
                      <input type="text" class="form-control" />
                   </div>
                </div>
                <div class="col-md-4">
                   <div class="form-group">
                     <label>Mode<span class="text-danger">*</span></label>
                        <select class="form-control">
                            <option>Car</option>
                            <option>Hotal</option>
                        </select>
                    </div>
                 </div>
                 <div class="col-md-4">
                    <div class="form-group">
                      <label>Car Type<span class="text-danger">*</span></label>
                         <select class="form-control">
                             <option>Hyundai Verna</option>
                             <option>Honda City</option>
                             <option>Skoda Octavia</option>
                             <option>Hyundai i20</option>
                         </select>
                     </div>
                  </div>
             </div>
             

             <div class="row">
                <div class="col-md-4">
                   <div class="form-group">
                      <label>Intra City<span class="text-danger">*</span></label>
                      <select class="form-control">
                        <option>Local</option>
                        <option>Outstation</option>
                    </select>
                   </div>
                </div>
                <div class="col-md-4">
                   <div class="form-group">
                     <label>Package<span class="text-danger">*</span></label>
                        <select class="form-control">
                            <option>one</option>
                            <option>one</option>
                        </select>
                    </div>
                 </div>
                 <div class="col-md-4">
                    <div class="form-group">
                      <label>Package Fare<span class="text-danger">*</span></label>
                         <select class="form-control">
                             <option>one</option>
                             <option>one</option>
                         </select>
                     </div>
                  </div>
             </div>
             

             <div class="row">
                <div class="col-md-4">
                   <div class="form-group">
                      <label>Extra Km Charges<span class="text-danger">*</span></label>
                      <select class="form-control">
                        <option>one</option>
                        <option>one</option>
                    </select>
                   </div>
                </div>
                <div class="col-md-4">
                   <div class="form-group">
                     <label>Extra Hr Charges<span class="text-danger">*</span></label>
                        <select class="form-control">
                            <option>one</option>
                            <option>one</option>
                        </select>
                    </div>
                 </div>
                 <div class="col-md-4">
                    <div class="form-group">
                       <label>Night Charges<span class="text-danger">*</span></label>
                       <select class="form-control">
                         <option>one</option>
                         <option>one</option>
                     </select>
                    </div>
                 </div>
             </div>

           
             <div class="row">
                <div class="col-md-4">
                   <div class="form-group">
                      <label>Cancellation TAT<span class="text-danger">*</span></label>
                      <select class="form-control">
                        <option>one</option>
                        <option>one</option>
                    </select>
                   </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                      <label>DA/Bhatta<span class="text-danger">*</span></label>
                         <select class="form-control">
                             <option>one</option>
                             <option>one</option>
                         </select>
                     </div>
                  </div>
                <div class="col-md-4">
                   <div class="form-group">
                     <label>Mini Cancellation charges<span class="text-danger">*</span></label>
                        <select class="form-control">
                            <option>one</option>
                            <option>one</option>
                        </select>
                    </div>
                 </div>
             </div>
             </fieldset>
            <fieldset class="mb-3">
                <legend class="cus-legend">Vendor Details</legend>

             <div class="row">
                <div class="col-md-4">
                   <div class="form-group">
                      <label>Vendor FullName<span class="text-danger">*</span></label>
                      <input type="text" class="form-control">
                   </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                      <label>Email<span class="text-danger">*</span></label>
                        <input type="text" class="form-control">
                     </div>
                  </div>
                <div class="col-md-4">
                   <div class="form-group">
                     <label>Phone<span class="text-danger">*</span></label>
                        <input type="text" class="form-control">
                    </div>
                 </div>
             </div>
            </fieldset>
  
  
           
  
           
         <div class="row">
             <div class="col-12 text-center">
                <button type="submit" class="btn btn-primary btn-sm "><i class="fa fa-save"></i> SAVE</button>
                <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" >Close</button>
             </div>
         </div>
            
   
            
        
             

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->         


